import { style } from '@vanilla-extract/css';

import { column } from '../columns/Column.css';
import { columns, stack } from '../columns/Columns.css';

// Side-by-side columns on phones are often narrower than the theme's side padding, which would shrink the image to nothing.
const sideBySideColumn = `${columns}:not(${stack}) > ${column}`;
const phone = 'only screen and (max-width:667px)';

export const imageBlockContainer = style({
  paddingLeft: 'var(--wt-padding-left-value-w-fallback)',
  paddingRight: 'var(--wt-padding-right-value-w-fallback)',
  '@media': {
    [phone]: {
      selectors: {
        [`${sideBySideColumn} > &`]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
  },
});

export const imagePaddingContainer = style({
  paddingBottom: 'var(--wt-image-padding-bottom, 20px)',
  paddingTop: 'var(--wt-image-padding-top, 20px)',
  paddingLeft: 'var(--wt-image-padding-left, 0px)',
  paddingRight: 'var(--wt-image-padding-right, 0px)',
  '@media': {
    [phone]: {
      selectors: {
        [`${sideBySideColumn} > ${imageBlockContainer} > &`]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
    },
  },
});

export const image = style({
  width: '100%',
});

export const imageAlignLeft = style({
  margin: '0 auto 0 0',
});

export const imageAlignRight = style({
  margin: '0 0 0 auto',
});

export const imageAlignCenter = style({
  margin: '0 auto 0 auto',
});
